"use client";

import { memo } from "react";
import { TableCell } from "@/shadcn-components/ui/table";
import type { OpenedTrade } from "@/vybe-trader-client/opened-trades";
import {
  selectOpenPositionMetrics,
  useOpenPositionsLiveMetricsStore,
} from "@/vybe-trader-client/opened-trades/stores/useOpenPositionsLiveMetricsStore";
import {
  OPEN_POSITION_COL_WIDTHS,
  openPositionsTd,
} from "./openPositionsTableLayout";

interface OpenPositionLiveCellsProps {
  trade: OpenedTrade;
  isMarket: boolean;
}

function OpenPositionLiveCellsInner({
  trade,
  isMarket,
}: OpenPositionLiveCellsProps) {
  const metrics = useOpenPositionsLiveMetricsStore(
    selectOpenPositionMetrics(trade.ticket)
  );

  if (!isMarket) {
    return (
      <>
        <TableCell className={`${openPositionsTd} ${OPEN_POSITION_COL_WIDTHS.current}`}>
          <span className="text-muted-foreground">-</span>
        </TableCell>
        <TableCell className={`${openPositionsTd} ${OPEN_POSITION_COL_WIDTHS.change}`}>
          <span className="text-muted-foreground">-</span>
        </TableCell>
        <TableCell className={`${openPositionsTd} ${OPEN_POSITION_COL_WIDTHS.pnl}`}>
          <span className="text-muted-foreground">-</span>
        </TableCell>
      </>
    );
  }

  const currentPrice = metrics?.currentPrice ?? trade.closePrice ?? trade.openPrice;
  const priceChange = metrics?.priceChange ?? 0;
  const liveProfit = metrics?.profit ?? 0;

  return (
    <>
      <TableCell className={`${openPositionsTd} ${OPEN_POSITION_COL_WIDTHS.current}`}>
        <span className="font-mono font-semibold tabular-nums">
          {currentPrice.toFixed(trade.digits)}
        </span>
      </TableCell>
      <TableCell className={`${openPositionsTd} ${OPEN_POSITION_COL_WIDTHS.change}`}>
        <span
          className={`font-mono tabular-nums ${
            priceChange >= 0 ? "text-blue-400" : "text-red-400"
          }`}
        >
          {priceChange >= 0 ? "+" : ""}
          {priceChange.toFixed(trade.digits)}
        </span>
      </TableCell>
      <TableCell className={`${openPositionsTd} ${OPEN_POSITION_COL_WIDTHS.pnl}`}>
        <span
          className={`font-semibold tabular-nums ${
            Math.abs(liveProfit) < 0.00000001
              ? "text-foreground"
              : liveProfit > 0
                ? "text-blue-400"
                : "text-red-400"
          }`}
        >
          {Math.abs(liveProfit) < 0.00000001
            ? liveProfit.toFixed(2)
            : liveProfit > 0
              ? `+${liveProfit.toFixed(2)}`
              : liveProfit.toFixed(2)}
        </span>
      </TableCell>
    </>
  );
}

export const OpenPositionLiveCells = memo(OpenPositionLiveCellsInner);
